export default {
  methods: {
    navigate(to) {
      this.$router.push(to);
    },

    replace(to) {
      this.$router.replace(to);
    },

    goTo(to) {
      this.$router.go(to);
    },

    currentRouteName() {
      return this.$router.currentRoute.name;
    },

    goToExternal(url) {
      location.replace(url);
    },

    externalBlank(url) {
      window.open(url, "_blank");
    },

    goBack() {
      this.goTo(-1)
    }
  }
};
